import tourManager from './TourManager'
import demoSession from './demo/DemoSession'
import { syncTourAccessBodyClass } from './tourUi'
import buildIntrodutorioTourSteps from './guides/introdutorioTour'
import buildBoasVindasTourSteps from './guides/boasVindasTour'
import buildNovoEquipamentoTourSteps from './guides/equipamento/novoEquipamentoTour'
import buildEditarEquipamentoTourSteps from './guides/equipamento/editarEquipamentoTour'
import buildParametrizacaoTourSteps from './guides/equipamento/parametrizacaoTour'
import buildComandosTourSteps from './guides/equipamento/comandosTour'
import buildNovoMonitoradoTourSteps from './guides/monitorado/novoMonitoradoTour'
import buildEditarMonitoradoTourSteps from './guides/monitorado/editarMonitoradoTour'
import buildListaMonitoradosTourSteps from './guides/monitorado/listaMonitoradosTour'
import buildNovoPerfilClienteTourSteps, { buildPerfilClienteFormTourSteps, buildPerfilClientePosSalvarTourSteps } from './guides/cliente/perfilClienteTour'
import buildNovoClienteTourSteps, { buildClientePosSalvarTourSteps } from './guides/cliente/novoClienteTour'
import buildEditarClienteTourSteps from './guides/cliente/editarClienteTour'
import buildReporteManualTourSteps from './guides/equipamento/reporteManualTour'
import buildNovoAutomacaoTourSteps from './guides/automacao/novoAutomacaoTour'
import buildEditarAutomacaoTourSteps from './guides/automacao/editarAutomacaoTour'
import buildNovoExportacaoTourSteps from './guides/exportacao/novoExportacaoTour'
import buildEditarExportacaoTourSteps from './guides/exportacao/editarExportacaoTour'
import buildSupervisorioTourSteps from './guides/supervisorio/supervisorioTour'
import buildDemoEquipamentoTourSteps from './demo/steps/demoEquipamentoTour'
import buildDemoParametrizacaoTourSteps from './demo/steps/demoParametrizacaoTour'
import buildDemoPerfilClienteTourSteps from './demo/steps/demoPerfilClienteTour'
import buildDemoClienteTourSteps from './demo/steps/demoClienteTour'
import buildDemoMonitoradoTourSteps from './demo/steps/demoMonitoradoTour'
import buildDemoMonitoradoDemoTourSteps from './demo/steps/demoMonitoradoDemoTour'

syncTourAccessBodyClass()
demoSession.bootstrap()

tourManager.registerTour('introdutorio', {
    startRoute: '/',
    startSelector: '[data-tour="dashboard-cards"]',
    buildSteps: buildIntrodutorioTourSteps,
})

tourManager.registerTour('boas-vindas', {
    startRoute: '/',
    startSelector: '[data-tour="dashboard-cards"]',
    buildSteps: buildBoasVindasTourSteps,
})

tourManager.registerTour('novo-equipamento', {
    startRoute: '/equipamento',
    startSelector: '[data-tour="grid-table"]',
    buildSteps: buildNovoEquipamentoTourSteps,
    getStartIndex: () => (window.location.pathname === '/equipamento/novo' ? 2 : 0),
})

tourManager.registerTour('editar-equipamento', {
    buildSteps: buildEditarEquipamentoTourSteps,
    readySelector: '[data-tour="equipamento-edit-root"][data-carregado="true"]',
})

tourManager.registerTour('parametrizacao', {
    buildSteps: buildParametrizacaoTourSteps,
    readySelector: '[data-tour="help-campo-parametrizado"]',
})

tourManager.registerTour('comandos', {
    buildSteps: buildComandosTourSteps,
    readySelector: '[data-tour="help-comando-customizado"]',
})

tourManager.registerTour('novo-monitorado', {
    startRoute: '/monitorado',
    startSelector: '[data-tour="help-monitorado-grid"]',
    buildSteps: buildNovoMonitoradoTourSteps,
})

tourManager.registerTour('editar-monitorado', {
    buildSteps: buildEditarMonitoradoTourSteps,
    readySelector: '[data-tour="monitorado-form-root"][data-carregado="true"]',
})

tourManager.registerTour('lista-monitorados', {
    startRoute: '/lista-monitorados',
    startSelector: '[data-tour="help-lista-monitorados"]',
    buildSteps: buildListaMonitoradosTourSteps,
})

tourManager.registerTour('novo-perfil-cliente', {
    startRoute: '/perfil/cliente',
    startSelector: '[data-tour="perfil-cliente-lista"]',
    buildSteps: buildNovoPerfilClienteTourSteps,
})

tourManager.registerTour('perfil-cliente-form', {
    buildSteps: buildPerfilClienteFormTourSteps,
    readySelector: '[data-tour="perfil-cliente-form-root"][data-carregado="true"]',
})

tourManager.registerTour('perfil-cliente-pos-salvar', {
    buildSteps: buildPerfilClientePosSalvarTourSteps,
})

tourManager.registerTour('novo-cliente', {
    startRoute: '/cliente',
    startSelector: '[data-tour="cliente-lista"]',
    buildSteps: buildNovoClienteTourSteps,
    getStartIndex: () => (window.location.pathname === '/cliente/novo' ? 2 : 0),
})

tourManager.registerTour('cliente-pos-salvar', {
    buildSteps: buildClientePosSalvarTourSteps,
})

tourManager.registerTour('editar-cliente', {
    buildSteps: buildEditarClienteTourSteps,
    readySelector: '[data-tour="cliente-form-root"][data-carregado="true"]',
})

tourManager.registerTour('reporte-manual', {
    startRoute: '/virtual',
    startSelector: '[data-tour="help-reporte-manual"], [data-tour="help-reporte-manual-form"]',
    buildSteps: buildReporteManualTourSteps,
})

tourManager.registerTour('novo-automacao', {
    startRoute: '/automacao',
    startSelector: '[data-tour="automacao-novo"], [data-tour="help-automacao-grid"]',
    buildSteps: buildNovoAutomacaoTourSteps,
    getStartIndex: () => (window.location.pathname === '/automacao/novo' ? 2 : 0),
    readySelector: '[data-tour="automacao-lista"], [data-tour="automacao-form-root"]',
})

tourManager.registerTour('editar-automacao', {
    buildSteps: buildEditarAutomacaoTourSteps,
    readySelector: '[data-tour="automacao-form-root"][data-carregado="true"]',
})

tourManager.registerTour('novo-exportacao-dados', {
    startRoute: '/exportacao-dados',
    startSelector: '[data-tour="exportacao-novo"], [data-tour="help-exportacao-grid"]',
    buildSteps: buildNovoExportacaoTourSteps,
    getStartIndex: () => (window.location.pathname === '/exportacao-dados/novo' ? 2 : 0),
    readySelector: '[data-tour="exportacao-lista"], [data-tour="exportacao-form-root"]',
})

tourManager.registerTour('editar-exportacao-dados', {
    buildSteps: buildEditarExportacaoTourSteps,
    readySelector: '[data-tour="exportacao-form-root"][data-carregado="true"]',
})

tourManager.registerTour('supervisorio', {
    startRoute: '/supervisorio',
    startSelector: '[data-tour="supervisorio-root"]',
    buildSteps: buildSupervisorioTourSteps,
    readySelector: '[data-tour="supervisorio-root"]',
})

tourManager.registerTour('demo-equipamento', {
    startRoute: '/',
    startSelector: '[data-tour="dashboard-cards"], [data-tour="menu-dashboard"]',
    buildSteps: buildDemoEquipamentoTourSteps,
})

tourManager.registerTour('demo-parametrizacao', {
    startRoute: '/equipamento',
    startSelector: '[data-tour="grid-table"], [data-tour="grid-novo-btn"], [data-tour="help-equipamento-grid"]',
    buildSteps: buildDemoParametrizacaoTourSteps,
})

tourManager.registerTour('demo-perfil-cliente', {
    startRoute: '/perfil/cliente',
    startSelector: '[data-tour="menu-perfis-cliente"], [data-tour="perfil-cliente-novo"], [data-tour="help-perfil-cliente-grid"], [data-tour="perfil-cliente-lista"]',
    buildSteps: buildDemoPerfilClienteTourSteps,
})

tourManager.registerTour('demo-cliente', {
    startRoute: '/cliente',
    startSelector: '[data-tour="menu-lista-clientes"], [data-tour="cliente-novo"], [data-tour="cliente-lista"]',
    buildSteps: buildDemoClienteTourSteps,
})

tourManager.registerTour('demo-monitorado', {
    startRoute: '/monitorado',
    startSelector: '[data-tour="menu-monitorados"], [data-tour="monitorado-novo"], [data-tour="monitorado-lista"]',
    buildSteps: buildDemoMonitoradoTourSteps,
})

tourManager.registerTour('demo-monitorado-demo', {
    startRoute: '/lista-monitorados',
    startSelector: '[data-tour="lista-monitorados-tabela"], [data-tour="help-lista-monitorados"]',
    buildSteps: buildDemoMonitoradoDemoTourSteps,
})

demoSession.startPendingRestart()

export default tourManager
